
"use strict";$(document).foundation();
//# sourceMappingURL=app.js.map

jQuery(document).ready(function( $ ) {

    // Open Card Reveal Click
    $('.open-button').click(function(){
        $('.card-reveal').removeClass('open');
        $(this).siblings('.card-reveal').toggleClass('open');
    });

    // Close Card Reveal Click
    $('.close-button').click(function(){
      $(this).parent().parent('.card-reveal').toggleClass('open');
    });

// Hamburger Menu
    $('#hamburger-toggle').on('click', function () {
        $(this).toggleClass('is-active');
        $('#top').toggleClass('opened');
    });
    $('#hamburger-overlay').on('click', function () {
        $('#hamburger-toggle').removeClass('is-active');
        $('#top').toggleClass('opened');
    });


    var activeMenu = $('.drilldown').find('.is-drilldown-submenu.is-active');
    activeMenu.removeClass('invisible').addClass("visible");


});



// <script src="assets/colorbox/js/colorbox.min.js?v=1.6.6"></script>
jQuery(function($){$('a[data-lightbox]').map(function(){$(this).colorbox({loop:!1,rel:$(this).attr('data-lightbox'),maxWidth:'95%',maxHeight:'95%'})})})
//jQuery(".is-drilldown").css({"overflow":"visible"});

//
// $(document).foundation();
//
// $(function(){
//   hasTouch = 'ontouchstart' in window || (typeof window.ontouchstart !== 'undefined');
//   if(!hasTouch){
//     var elem = new Foundation.DropdownMenu($('.dropdown.menu'));
//   }
// });
